import $ from "dabbyjs/src/core/dabby/dabby.js";
import chart from "../../../swgfl/report/javascript/chart.js";
import print from "../../../swgfl/javascript/print.js";
import tableRowLink from "../../javascript/table-row-link.js";

chart($(".report__chart-canvas"));
print($("[data-print]"));
tableRowLink($(".report__section .cms-list__table"));